
<template>
  <div>    
    <v-dialog v-if="dialog" v-model="dialog" persistent transition="dialog-bottom-transition" scrollable width="600px">
      <!-- <template v-slot:activator="{ on }">
        <v-btn color="primary" dark v-on="on" small>Descrição</v-btn>
      </template> -->
      <v-card v-if="dialog">
        <v-card-title primary-title class="pa-0">
          <v-toolbar dark color="primary" >
            <v-toolbar-title>Descrição</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="$emit('closeDescriptionDialog')" dark>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
        </v-card-title>
        <v-card-text>
          <v-textarea readonly :value="description"></v-textarea>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'ShowDesciptionDialog',
  props: {
    item: {
      type: Object
    },
    dialog: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      description: '',
    }
  },
  mounted () {
    this.setDescription();
  },
  methods: {
    setDescription() {
      this.description = this.item.json_attributes ? this.item.json_attributes.description : this.item.description;
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>